const getAddressLineParts = (rawAddress = {}) => {
  const {
    address_line_1: generatedAddressLine,
    organisation_name: organisation,
  } = rawAddress;

  if (generatedAddressLine) {
    return [organisation, generatedAddressLine];
  }

  const {
    address_prefix: prefix,
    house_number: houseNumber,
    street,
    street_name: streetName,
  } = rawAddress;
  return [
    organisation,
    prefix,
    `${houseNumber ?? ''} ${street || streetName}`.trim(),
  ];
};

export const parseCustomerDetailsReponse = (data) => {
  if (!data) {
    return null;
  }

  const { contact_details: contactDetails, personal_details: personalDetails } =
    data;
  const {
    phone: { mobile, home: landline },
    email,
    preferences: {
      contact: { method: contactPreference },
    },
  } = contactDetails;

  const [firstAddress] = personalDetails.addresses ?? [{}]; // Edge case;
  const { uk_address: rawAddress } = firstAddress;

  const addressLine = getAddressLineParts(rawAddress)
    .filter(Boolean)
    .join(', ');

  return {
    email,
    mobile,
    landline,
    contactPreference,
    addressElements: [
      addressLine,
      rawAddress?.city,
      rawAddress?.county,
      rawAddress?.postal_code,
    ].filter((item) => item?.trim()),
  };
};
